// Lib
import { FormControl, FormErrorMessage, FormHelperText, FormLabel, Select as ChakraSelect } from "@chakra-ui/react"

export default function Select({ label, value, helper, error, placeholder, options = [], ...props}){
    return(
    <FormControl isInvalid={!!error}>
        { label && <FormLabel fontSize="sm" children={label} /> }
        <ChakraSelect value={value ?? ''} {...props}>
            <option value="" disabled>{placeholder ?? 'Selecione uma opção'}</option>
            {options?.map(item => (
                <option key={item?.value ?? item?.label} value={item?.value ?? ''}>
                    {item?.label}
                </option>
            ))}
        </ChakraSelect>
        { !!error && <FormErrorMessage children={error} /> }
        { (!error && !!helper) && <FormHelperText children={helper} />}
    </FormControl>
    )
}